import { useContext } from "react";
import { Avatars, PlayerImageAndUpScore } from "..";
import { TeamContext } from "../../../context";
import { BluredBlueModal } from "../../atoms";

const GameWinnersPodium = () => {
    const { game } = useContext(TeamContext);
    let playerWithMostUpper: any[] = [];
    let listOfPlayers = game?.gameInfo?.players;
    let notEnoughtPlayerss: boolean = listOfPlayers.length < 3;

    if (notEnoughtPlayerss) return <div></div>

    for (const user in listOfPlayers) {
        playerWithMostUpper.push({
            email: user,
            nickName: game?.players.find( (player: any) => player.email === user )?.nickname,
            upper: listOfPlayers[user]?.upperTokens || 0,
            color: listOfPlayers[user]?.color || "pink"
        })
    }

    if(!playerWithMostUpper)  return(<div></div>);
    if(playerWithMostUpper?.length < 3) return <div></div> 

    playerWithMostUpper.sort ( (firstPlayer: any, secondPlayer: any) => {
        if (firstPlayer?.upper > secondPlayer?.upper) return -1;
        if (firstPlayer?.upper < secondPlayer?.upper) return 1;
        return 0;
    })

    return (
        <BluredBlueModal>      
            <div className="center_horizontally_and_vertically" style={{transform: "scale(0.8)", flexDirection: "column"}}>
                <Avatars playerWithMostUpper={playerWithMostUpper} />
                <PlayerImageAndUpScore playerWithMostUpper={playerWithMostUpper} />
            </div>
        </BluredBlueModal>
    )
}

export default GameWinnersPodium;